import React from 'react';
import { useTranslation } from 'react-i18next';

function BtnDelete({ isDisabled, multiDelete, title, isProductArchived }) {
  const { t } = useTranslation('common');

  return (
    <button
      onClick={multiDelete}
      disabled={isDisabled || isProductArchived}
      className="filter-btn filter-button_delete"
      title={title || t('COMPONENT.FILTER_ACTION.BTN_DELETE.DELETE')}
      type="button"
    >
      <i className="icon-Delete f-24" />
      <span className="text-icon">{t('BTN_CLOCK.INSTANT_REQUEST')}</span>
    </button>
  );
}

export default BtnDelete;
